import Vue from 'vue';
import { createApp } from '../app';
import '../util/promisePollfill';
import * as sonicHelper from '../util/sonicHelper';
import { registerWebbundleEvents } from '@/util/webbundle/preload-util';
import '@/polyfill/promise';
import { logger } from '@/util/logger';

if (process.env.NODE_ENV === 'development'/* || process.env.VUE_APP_PUBLIC_ENV === 'pre' */) {
  const VConsole = require('vconsole');
  const vConsole = new VConsole();
  logger.info(`vconsole version: ${vConsole.version}`);
}
Vue.mixin({
  beforeRouteUpdate(to, from, next) {
    const { asyncData } = this.$options;
    if (typeof asyncData === 'function') {
      asyncData.call(this.$options, {
        store: this.$store,
        route: to,
      }).then(next)
        .catch(next);
    } else {
      next();
    }
  },
  beforeCreate() {
    if (this.$store && typeof (this.$store.registerModules) === 'function' && this.$options.storeModules) {
      this.$store.registerModules(this.$options.storeModules);
    }
  },
  destroyed() {
    if (this.$store && typeof (this.$store.unregisterModules) === 'function' && this.$options.storeModules) {
      this.$store.unregisterModules(this.$options.storeModules);
    }
  },
});

const { app, router, store } = createApp();

// 通过引用类型 ssrData 传递preData数据
const ssrData = {};
registerWebbundleEvents({ store, router });

const routerReady = () => {
  sonicHelper.onReady(() => {
    router.beforeResolve((to, from, next) => {
      // webbundle走 registerWebbundleEvents 里面的逻辑
      if (from.name === 'preload-loading') return next();
      const matched = router.getMatchedComponents(to);
      const prevMatched = router.getMatchedComponents(from);
      const total = matched.length - 1;
      let i = 0;
      while (i <= total) {
        if (matched[i] !== prevMatched[i]) {
          break;
        }
        i += 1;
      }
      if (i > total) {
        next();
      } else {
        Promise.all(matched.slice(i).map((component) => {
          if (typeof component.asyncData === 'function') {
            return component.asyncData({
              store: store.registerAllModules(component),
              route: to,
            }, ssrData.preData);
          }
          return Promise.resolve();
        })).finally(() => {
          next();
        });
        // 在destory钩子中移除
        // .then(() => {
        //   prevMatched.slice(i).forEach((component) => {
        //     store.unregisterAllModules(component);
        //   });
        //   next();
        // }).catch(() => {
        //   prevMatched.slice(i).forEach((component) => {
        //     store.unregisterAllModules(component);
        //   });
        //   next();
        // });
      }
    });
    app.$mount('#app');
  });
};

// eslint-disable-next-line no-underscore-dangle
if (window.__INITIAL_STATE__) {
  // eslint-disable-next-line no-underscore-dangle
  store.replaceState(window.__INITIAL_STATE__);
  router.onReady(routerReady);
} else {
  routerReady();
}



// WEBPACK FOOTER //
// ../src/entry/client.js